var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14695_2563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.74375 5.59319C7.41875 5.91819 7.41875 6.44319 7.74375 6.76819L10.9771 10.0015L7.74375 13.2349C7.41875 13.5599 7.41875 14.0849 7.74375 14.4099C8.06875 14.7349 8.59375 14.7349 8.91875 14.4099L12.7438 10.5849C13.0687 10.2599 13.0687 9.73486 12.7438 9.40986L8.91875 5.58486C8.60208 5.26819 8.06875 5.26819 7.74375 5.59319Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14695_2563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight1);
export default __webpack_public_path__ + "static/media/icon_arrow_right_1.b99538756361dfd117269f6efe88f8f9.svg";
export { ForwardRef as ReactComponent };